var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidePass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6131C6.72167 11.6131 3.44334 10.0851 0.188339 7.02968C-0.0583273 6.79767 -0.062494 6.41845 0.178339 6.18084C0.420006 5.94402 0.815006 5.94002 1.06251 6.17123C7.07668 11.8172 12.9242 11.8172 18.9383 6.17123C19.1858 5.94002 19.5817 5.94402 19.8225 6.18084C20.0642 6.41765 20.0592 6.79767 19.8125 7.02968C16.5567 10.0851 13.2783 11.6131 10 11.6131Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.0005C9.655 14.0005 9.375 13.7317 9.375 13.4005V11.2003C9.375 10.8691 9.655 10.6003 10 10.6003C10.345 10.6003 10.625 10.8691 10.625 11.2003V13.4005C10.625 13.7317 10.345 14.0005 10 14.0005Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 10.2859C19.1958 10.2859 19.0183 10.2123 18.895 10.0699L17.395 8.34417C17.1733 8.08975 17.2091 7.71133 17.4741 7.49931C17.7383 7.2865 18.1341 7.3217 18.3541 7.57532L19.8541 9.30102C20.0758 9.55544 20.0399 9.93386 19.775 10.1459C19.6583 10.2403 19.5166 10.2859 19.375 10.2859Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.625026 10.2002C0.479192 10.2002 0.331692 10.1506 0.213359 10.0506C-0.0466417 9.83223 -0.0716417 9.45301 0.155859 9.20419L1.65586 7.56411C1.88253 7.3145 2.27836 7.2905 2.53753 7.50891C2.79753 7.72732 2.82253 8.10654 2.59503 8.35535L1.09503 9.99543C0.971693 10.1314 0.79836 10.2002 0.625026 10.2002Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2084 12.8004C14.985 12.8004 14.7684 12.6852 14.6559 12.4828L13.6142 10.6043C13.4525 10.3115 13.5675 9.94825 13.8725 9.79224C14.175 9.63703 14.5559 9.74664 14.7184 10.0403L15.76 11.9187C15.9217 12.2116 15.8067 12.5748 15.5017 12.7308C15.4084 12.778 15.3084 12.8004 15.2084 12.8004Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79183 12.8004C4.69267 12.8004 4.59183 12.778 4.4985 12.73C4.1935 12.574 4.0785 12.2108 4.24017 11.9179L5.28184 10.0394C5.4435 9.74663 5.82267 9.63703 6.12767 9.79144C6.43267 9.94745 6.54767 10.3107 6.386 10.6035L5.34434 12.482C5.231 12.6852 5.01517 12.8004 4.79183 12.8004Z",
    fill: "#9B9B9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePass);
export default __webpack_public_path__ + "static/media/hide-pass.33f1a888851484bbaf3635931f616152.svg";
export { ForwardRef as ReactComponent };